import { createUseStyles } from 'react-jss';
// Sonarcube asked for a constant
const boldText = '500 !important';

export default createUseStyles(theme => ({
  root: {
    backgroundColor: 'red',
  },
  topBanner: {
    width: '100% !important',
    height: '460px',
    backgroundColor: '#FFFDED',
    maxWidth: `${window.innerWidth} !important`,
  },

  bannerTitle: {
    fontWeight: boldText,
  },

  bannerBody: {
    width: '480px',
  },

  bannerButton: {
    marginTop: '25px',
  },

  bannerCTA: {
    marginRight: '80px',
  },

  linkIcon: {
    marginBottom: '-1px',
  },
  sectionTitle: {
    fontWeight: boldText,
    marginTop: '56px',
  },
  centerText: {
    textAlign: 'center',
  },

  addOnCard: {
    height: '280px',
    width: '308px',
    borderRadius: '8px',
    border: '2px solid #D1D3D4',
    padding: '40px 32px 32px 32px',
    marginTop: '25px',
  },

  addOnContainer: {
    paddingRight: '197px !important',
    paddingLeft: '197px !important',
    marginBottom: '55px',
  },

  addOnCardTitle: {
    fontSize: '20px !important',
    fontWeight: '500',
  },

  addOnCardButton: {
    marginTop: 'auto',
  },

  expertServicesPanel: {
    width: '100%',
    height: '670px',
    backgroundColor: '#051C4F',
    paddingTop: '56px',
  },

  lightTitle: {
    color: '#fff',
    fontWeight: boldText,
  },

  lightBody: {
    color: '#fff',
    padding: '0px 33%',
    fontSize: '16px',
  },

  row: {
    width: '100%',
  },

  testimonialCard: {
    border: '2px solid #53225B',
    borderRadius: '16px 16px 16px 0px',
    height: '356px',
    width: '308px',
    marginTop: '32px',
    backgroundColor: '#fff',
    marginLeft: '12px',
    marginRight: '12px',
    padding: '16px 16px 25px 16px',
  },

  chimeBox: {
    backgroundColor: '#F7F2FD',
    height: '250px',
    width: '95%',
    color: '#53225B',
    paddingLeft: '16px',
    paddingTop: '16px',
  },

  pumaBox: {
    backgroundColor: '#FEF0F1',
    height: '250px',
    width: '95%',
    color: '#902B3C',
    paddingLeft: '16px',
    paddingTop: '16px',
  },

  colgateBox: {
    backgroundColor: '#EEF9FE',
    height: '250px',
    width: '95%',
    color: '#051C4F',
    paddingLeft: '16px',
    paddingTop: '16px',
  },

  testimonialBody: {
    width: '90%',
    marginTop: '15px',
  },

  quoteBox: {
    marginTop: '16px',
  },

  mrxCard: {
    height: '370px',
    width: '308px',
    marginTop: '25px',
  },
  mrxCardInnerBox: {
    backgroundColor: '#F5FAF6',
    height: '40%',
  },
  mrxButton: {
    width: '150px',
    marginTop: 'auto',
  },

  mrxCardBody: {
    paddingRight: '16px',
  },
  modalContainer: {
    '&.wds-modal--md .wds-modal__modal ': {
      borderRadius: '16px !important',
      padding: '48px',
      backgroundColor: '#fff',

      '&.wds-modal__body': {
        backgroundColor: '#fff',
      },
    },
  },
  modalTitle: {
    fontSize: '24px',
    fontWeight: '500',
    fontFamily: theme.type.fontFamily.base,
    color: '#333E48',
  },
  modalButton: {
    width: '160px',
  },
  checkMark: {
    marginRight: '5px',
    height: '12px',
    width: '16px',
  },
  inlineLink: {
    margin: '0px 5px',
  },
}));
